import { axios } from '@Api/axiosClient';
import type { InviteCodeContext } from '@Types/InviteCodeContext.interface';
import type { RequestSummary } from '@Types/RequestSummary.interface';

const baseUrl: string = 'api/ActivitySession';

export const verifyUserApi = async (): Promise<string> => {
    const response = await axios.get(`${baseUrl}/VerifyUser`);
    return response ? response.data : '';
};

export const addRequestDetailsToActivitySessionByRecipientTokenApi = async (
    context: InviteCodeContext,
): Promise<void> => {
    await axios.post(
        `${baseUrl}/AddRequestDetailsToActivitySessionByInviteCode`,
        context,
    );
};

export const getRequestSummaryByActivitySessionApi =
  async (): Promise<RequestSummary> => {
      const response = await axios.get(`${baseUrl}/GetRequestByActivitySession`);
      return response ? response.data : ({} as RequestSummary);
  };

export const validateAndApplyQrSessionTokenApi = async (
    payload: { qrSessionToken: string },
): Promise<{ valid: boolean } | undefined> => {
    try {
        const response = await axios.post<{ valid: boolean }>(
            `${baseUrl}/ValidateAndApplyQrSessionToken`,
            payload,
        );
        return response.data;
    } catch (error) {
        console.warn('[Request MFE] ValidateAndApplyQrSessionToken failed:', error);
        return undefined;
    }
};
